module.exports = __webpack_public_path__ + "img/groceries.5c6320e9.svg";